import React, { type ComponentProps } from 'react';
import { Empty as AntdEmpty } from 'antd';
import { FormattedMessage } from 'react-intl';
import styled from '@emotion/styled';
import EmptyStateLayout from 'components/common/empty-state-layout';

// antd's props type omits `data-e2e`, so it is forwarded by hand.
export type EmptyProps = ComponentProps<typeof AntdEmpty> & { 'data-e2e'?: string };

// antd Empty is embedded (cards, a 200px VCS panel, table bodies), so the design's artwork renders at
// the 64x42 the frames embed it at (210:8458 in 218:13015).

const EmptyComponent: React.FunctionComponent<EmptyProps> = props => {
  return (
    <EmbeddedEmptyStateLayout
      illustration="empty-state"
      description={props.description ?? <FormattedMessage id="no.data" />}
      action={props.children}
      className={props.className}
      data-e2e={props['data-e2e'] ?? 'empty'}
    />
  );
};

const EmbeddedEmptyStateLayout = styled(EmptyStateLayout)`
  svg[data-illustration] {
    width: 64px;
    height: 42px;
  }
`;

// Here because this is the file the lint rule lets import antd's Empty; antd-wrapper picks who gets it.
export const CompactEmpty: React.FunctionComponent = () => (
  <AntdEmpty image={AntdEmpty.PRESENTED_IMAGE_SIMPLE} className="ant-empty-small" />
);

export const Empty = Object.assign(EmptyComponent, {
  PRESENTED_IMAGE_SIMPLE: AntdEmpty.PRESENTED_IMAGE_SIMPLE,
  PRESENTED_IMAGE_DEFAULT: AntdEmpty.PRESENTED_IMAGE_DEFAULT
});

export default Empty;
